export default "__VITE_ASSET__85b12720__"